<template>
  <v-container 
    fluid
    :fill-height="fillHeight"
    >
    <v-row align="center" justify="center">
      <v-col align="center">
      <v-toolbar
        elevation='24'
        rounded
        dark
        color="light-blue darken-4"
        max-width="400"
      >
        <!-- <v-toolbar-title>Suburb</v-toolbar-title> -->
        <v-autocomplete
          v-model="selectedSuburb"
          :loading="loading"
          :items="items"
          :search-input.sync="search"
          cache-items
          class="mx-4"
          flat
          hide-no-data
          hide-details
          label="Suburb search"
          solo-inverted
          @change="suburbSelectedRedir()"
        ></v-autocomplete>
        <v-btn icon>
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </v-toolbar>
    </v-col>
    </v-row>
    <div class="container">
    <div v-for="subs in suburbsFullshow" :key="subs">
          <Post :post="subs" />
    </div>
  </div>
  </v-container>
  
</template>

<script>
  import suburbsList from '../assets/suburbs_min.json'
  // import suburbsFull from '../assets/suburbs_full_prod.json'
  import Post from './SuburbDetails.vue'

  export default {
    name: 'Search',
    data () {
      return {
        suburbsList: suburbsList,
        // suburbsFull,
        suburbsFullshow: null,
        loading: false,
        items: [],
        search: null,
        select: null,
        selectedSuburb: null,
        fillHeight: true
      }
    },
  components: {
    Post
  },
    watch: {
      search (val) {
        val && val !== this.select && this.querySelections(val)
      },
    },
    methods: {
      querySelections (v) {
        this.loading = true
        // Simulated ajax query
        setTimeout(() => {
          this.items = this.suburbsList.filter(e => {
            return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
          })
          this.loading = false
        }, 500)
      },
      suburbSelectedRedir(){
        console.log(this.selectedSuburb)
        this.$router.push('/suburb?name='+this.selectedSuburb) 
      }
    },
  }
</script>